import React from 'react';
import { CheckIcon } from 'lucide-react';
const patients = ['guarda silencio.', 'responde con un “no sé”.', 'evita el tema.', 'cambia constantemente de conversación.', 'llega con un trauma complejo.', 'tiene problemas de pareja.', 'presenta resistencia.'];
export function ImagineSection() {
  return <section className="bg-gradient-to-b from-[#5b2580] to-[#4a1d6a] px-4 py-14 text-white" data-id="element-154" data-mp="11qbzib6re7q9">
      <div className="mx-auto max-w-md text-center" data-id="element-155" data-mp="nr2kheuahjnv">
        <h2 className="font-display text-3xl font-bold leading-tight" data-id="element-156" data-mp="sqyqfjmjrl62">
          Imagina entrar a cada sesión sabiendo{' '}
          <span className="text-pink" data-id="element-157" data-mp="duheaq6ja2ig">exactamente qué preguntar.</span>
        </h2>
        <p className="mt-4 text-[15px] text-white/75" data-id="element-158" data-mp="isivt6ob9trt">No importa si el paciente:</p>

        <div className="mt-5 space-y-2.5 text-left" data-id="element-159" data-mp="287pekxda36bh">
          {patients.map(p => <div key={p} className="flex items-center gap-3 rounded-xl border border-white/10 bg-white/5 px-4 py-3" data-id="element-160" data-mp="285w57aba67zs">
              <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-pink/20" data-id="element-161" data-mp="hur0vt7xzm71">
                <CheckIcon className="h-4 w-4 text-pink" data-id="element-162" data-mp="cwfphe2013mp" />
              </span>
              <span className="text-sm font-medium text-white/90" data-id="element-163" data-mp="rktrxnvi6q2q">{p}</span>
            </div>)}
        </div>

        <p className="mt-7 text-[15px] font-medium leading-relaxed text-white/90" data-id="element-164" data-mp="mnacikn2k797">
          Siempre tendrás una <span className="font-bold text-pink" data-id="element-165" data-mp="3v2u31bwcvbkk">ruta clara</span> para conducir
          la sesión con confianza.
        </p>
      </div>
    </section>;
}